module.exports = __webpack_public_path__ + "img/女-膀胱癌h.23ca807c.png";